import { FormlyFieldConfig } from "@ngx-formly/core";
import { FieldDefinitionConditions } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-conditions";
import { FieldDefinitionFields } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-fields";
import { Injector } from "@angular/core";
import { EntityEnum } from "../../../EntityEnum";
import { MedicinalProductsQueryNode } from "../../MedicinalProductsQueryNode";
import { Art57Section } from "../../../../Art57Section/Art57Section";
import { AutoUploadEntityEnum as AutoUploadEntityEnum } from "../../../../AutoUploadEntityEnum";
import { TreeNodeProductsList } from "../../../Art57Node/ListEntity/TreeNodeProductsList";

export class DevelopmentProductsValidVersionQueryNode extends MedicinalProductsQueryNode {
    constructor(injector: Injector) {
    const queryFields: FormlyFieldConfig[] =  new FieldDefinitionFields(injector).developmentProductsFields;
    const createChidTemplateParams = {nodeTypeToCreateName: 'addDevelopmentProduct'};
    const queryConditions: FormlyFieldConfig[] = new FieldDefinitionConditions(injector).developmentProductsConditions;
       super(injector, [], 'Development Products (Valid Version)', EntityEnum.developmentProductValidVersion,  queryFields, queryConditions, injector.get(Art57Section).medicinalProduct.developmentProductTreeNode, TreeNodeProductsList, AutoUploadEntityEnum.developmentProduct, createChidTemplateParams);    
    }
}